import { render } from "./NotificationToast.vue?vue&type=template&id=23aa1d5e&scoped=true&ts=true"
import script from "./NotificationToast.vue?vue&type=script&lang=ts"
export * from "./NotificationToast.vue?vue&type=script&lang=ts"

import "./NotificationToast.vue?vue&type=style&index=0&id=23aa1d5e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aa1d5e"]])

export default __exports__